import React from 'react';
import { MapPin, Phone, Mail, Linkedin, Twitter } from 'lucide-react';
import { companyInfo, contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Sectors', href: '#sectors' },
    { name: 'Partners', href: '#partners' },
    { name: 'Team', href: '#team' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'IoT Solutions',
    'Blockchain Development',
    'AI & Machine Learning',
    'Enterprise Software',
    'Device Management',
    'Business Applications'
  ];

  return (
    <footer className="dark-container py-16 border-t" style={{ 
      borderColor: 'rgba(255, 255, 255, 0.1)',
      marginTop: '0'
    }}>
      <div className="dark-content-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Company Info */}
          <div className="space-y-6">
            <div>
              <div className="flex items-center mb-4">
                <img 
                  src="/nfit-logo-clean.png" 
                  alt="NFIT Corp Logo" 
                  className="h-8 w-auto object-contain"
                  style={{ filter: 'brightness(1.2)' }}
                />
              </div>
              <p className="body-medium max-w-xs">
                {companyInfo.description}
              </p>
            </div>
            
            <div className="flex space-x-4">
              <button className="p-2 rounded-lg dark-transition" style={{ 
                background: 'rgba(0, 255, 209, 0.1)' 
              }}>
                <Linkedin size={20} style={{ color: '#00FFD1' }} />
              </button>
              <button className="p-2 rounded-lg dark-transition" style={{ 
                background: 'rgba(0, 255, 209, 0.1)' 
              }}>
                <Twitter size={20} style={{ color: '#00FFD1' }} />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-2 mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="body-medium text-gray-400 hover:text-white dark-transition"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-2 mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service} className="flex items-center space-x-2">
                  <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#00FFD1' }}></div>
                  <span className="body-medium text-gray-400">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-2 mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin size={18} style={{ color: '#00FFD1', marginTop: '2px' }} />
                <p className="body-small text-gray-400">{contactInfo.address}</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <Phone size={18} style={{ color: '#00FFD1' }} />
                <p className="body-small text-gray-400">{contactInfo.phone}</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <Mail size={18} style={{ color: '#00FFD1' }} />
                <p className="body-small text-gray-400">{contactInfo.email}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t" style={{ borderColor: 'rgba(255, 255, 255, 0.1)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-8">
              <p className="body-small text-gray-400">
                © {currentYear} NFIT Corp. All rights reserved.
              </p>
              <p className="body-small text-gray-400">
                Sister company of NF Infratech
              </p>
            </div>
            
            <div className="flex space-x-6">
              <a href="#" className="body-small text-gray-400 hover:text-white dark-transition">
                Privacy Policy
              </a>
              <a href="#" className="body-small text-gray-400 hover:text-white dark-transition">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;